import type { TableColumns } from '@ohpen/enso-ui';
import { RATE_DECIMALS } from '@pmp/utils';
import { BaseRateResponse, FieldType, InterestRateRequest, InterestRate } from '@pmp/api';

export const baseRateColumns: TableColumns<BaseRateResponse> = [
  {
    title: 'pmp.baseRates.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 270,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.code',
    dataIndex: 'code',
    key: 'code',
    width: 170,
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'rate',
    key: 'rate',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: RATE_DECIMALS,
      },
      filter: 'number',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    width: 160,
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    width: 160,
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.variabilityType',
    dataIndex: 'variabilityType',
    key: 'variabilityType',
    width: 200,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.VARIABILITY_TYPE,
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.variabilityTypeId',
    dataIndex: 'variabilityType',
    key: 'variabilityTypeId',
    width: 210,
    options: {
      format: {
        type: 'valueListKey',
      },
      filter: 'select',
      listName: FieldType.VARIABILITY_TYPE,
      hide: true,
      hideInForm: true,
    },
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const historicColumns: TableColumns<InterestRate> = [
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'amount',
    key: 'rate',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: RATE_DECIMALS,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    width: 140,
    options: {
      filter: 'date',
    },
  },
  {
    title: 'pmp.baseRates.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    width: 140,
    options: {
      filter: 'date',
    },
  },
  {
    title: 'pmp.baseRates.labels.index',
    dataIndex: 'index',
    key: 'index',
    width: 120,
    options: {
      filter: 'number',
      sorter: true,
    },
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const baseRateChangeColumns: TableColumns<BaseRateResponse> = [
  {
    title: 'pmp.baseRates.labels.name',
    dataIndex: 'name',
    key: 'name',
    width: 270,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.code',
    dataIndex: 'code',
    key: 'code',
    width: 170,
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'amount',
    key: 'amount',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: RATE_DECIMALS,
      },
      filter: 'number',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    width: 160,
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.variabilityType',
    dataIndex: 'variabilityType',
    key: 'variabilityType',
    width: 200,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.VARIABILITY_TYPE,
      sorter: true,
    },
  },
];

export const interestRateColumns: TableColumns<InterestRateRequest> = [
  {
    title: 'pmp.baseRates.labels.baseRateCode',
    dataIndex: 'baseRateCode',
    key: 'baseRateCode',
    width: 170,
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'amount',
    key: 'amount',
    width: 120,
    options: {
      format: {
        type: 'percentage',
        decimalScale: RATE_DECIMALS,
      },
      filter: 'number',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    width: 140,
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.index',
    dataIndex: 'index',
    key: 'index',
    width: 120,
    options: {
      filter: 'number',
      sorter: true,
    },
  },
];
